import React from 'react';
import { Link } from "react-router-dom";

export default function About({isLoading, pages}){

	return (
		<footer><h2><Link to='/'>↖&#xFE0E; back to the clocks</Link></h2></footer>
	)}